"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayOfItemTuples = void 0;
const e_1 = require("e");
const itemID_1 = __importDefault(require("../util/itemID"));
const Bank_1 = __importDefault(require("./Bank"));
function isArrayOfItemTuples(x) {
    return Array.isArray(x[0]);
}
exports.isArrayOfItemTuples = isArrayOfItemTuples;
class LootTable {
    constructor(lootTableOptions = {}) {
        this.table = [];
        this.oneInItems = [];
        this.tertiaryItems = [];
        this.everyItems = [];
        this.length = 0;
        this.totalWeight = 0;
        this.limit = lootTableOptions.limit;
        this.allItems = [];
    }
    clone() {
        const newTable = new LootTable();
        newTable.table = [...this.table];
        newTable.oneInItems = [...this.oneInItems];
        newTable.tertiaryItems = [...this.tertiaryItems];
        newTable.everyItems = [...this.everyItems];
        newTable.length = this.length;
        newTable.totalWeight = this.totalWeight;
        newTable.limit = this.limit;
        newTable.allItems = [...this.allItems];
        return newTable;
    }
    resolveName(name) {
        return itemID_1.default(name);
    }
    addToAllItems(items) {
        if (Array.isArray(items)) {
            for (const item of items) {
                this.addToAllItems(item);
            }
            return;
        }
        if (items instanceof LootTable) {
            this.allItems = Array.from(new Set(this.allItems.concat(Array.isArray(items) ? items : items.allItems)));
            return;
        }
        if (typeof items === 'number') {
            if (this.allItems.includes(items))
                return;
            this.allItems.push(items);
        }
        else {
            this.addToAllItems(items.item);
        }
    }
    oneIn(chance, item, quantity = 1) {
        const resolved = typeof item === 'string' ? this.resolveName(item) : item;
        this.oneInItems.push({
            item: resolved,
            chance,
            quantity
        });
        this.addToAllItems(resolved);
        return this;
    }
    tertiary(chance, item, quantity = 1) {
        const resolved = typeof item === 'string' ? this.resolveName(item) : item;
        this.tertiaryItems.push({
            item: resolved,
            chance,
            quantity
        });
        this.addToAllItems(resolved);
        return this;
    }
    every(item, quantity = 1) {
        const resolved = typeof item === 'string' ? this.resolveName(item) : item;
        this.everyItems.push({
            item: resolved,
            quantity
        });
        this.addToAllItems(resolved);
        return this;
    }
    add(item, quantity = 1, weight = 1) {
        if (this.limit && weight + this.totalWeight > this.limit) {
            throw new Error('Loot table total weight exceeds limit');
        }
        if (typeof item === 'string') {
            return this.add(this.resolveName(item), quantity, weight);
        }
        // If its an array, but not a LootTableItem[] array.
        // i.e, if its directly from the user, and not being internally added.
        if (Array.isArray(item) && isArrayOfItemTuples(item)) {
            const newItems = [];
            const _item = item;
            for (const itemToAdd of _item) {
                const resolvedId = this.resolveName(itemToAdd[0]);
                this.addToAllItems(resolvedId);
                newItems.push({
                    item: resolvedId,
                    quantity: this.determineQuantity(itemToAdd[1]) || 1
                });
            }
            return this.add(newItems, quantity, weight);
        }
        this.length += 1;
        this.totalWeight += weight;
        this.addToAllItems(item);
        this.table.push({
            item,
            weight,
            quantity
        });
        return this;
    }
    roll(quantity = 1) {
        const loot = new Bank_1.default();
        outerLoop: for (let i = 0; i < quantity; i++) {
            // The items that are rolled.
            for (const item of this.everyItems) {
                this.addResultToLoot(item, loot);
            }
            for (const { chance, item, quantity } of this.tertiaryItems) {
                if (e_1.roll(chance))
                    this.addResultToLoot({ item, quantity }, loot);
            }
            for (const { chance, item, quantity } of this.oneInItems) {
                if (e_1.roll(chance)) {
                    this.addResultToLoot({ item, quantity }, loot);
                    continue outerLoop;
                }
            }
            // Random float between 0 and the total weighting
            const randomWeight = e_1.randFloat(0, this.limit || this.totalWeight);
            // The index of the item that will be used.
            let result;
            let weight = 0;
            for (let i = 0; i < this.table.length; i++) {
                const item = this.table[i];
                weight += item.weight;
                if (randomWeight <= weight) {
                    result = i;
                    break;
                }
            }
            const chosenItem = this.table[result];
            this.addResultToLoot(chosenItem, loot);
        }
        return loot;
    }
    addResultToLoot(result, loot) {
        if (!result)
            return;
        const { item, quantity } = result;
        if (Array.isArray(item)) {
            for (const singleItem of item) {
                this.addResultToLoot(singleItem, loot);
            }
            return;
        }
        const qty = this.determineQuantity(quantity);
        if (item instanceof LootTable) {
            loot.add(item.roll(qty));
            return;
        }
        loot.add(item, qty);
    }
    determineQuantity(quantity) {
        if (Array.isArray(quantity)) {
            return e_1.randInt(quantity[0], quantity[1]);
        }
        else {
            return quantity;
        }
    }
}
exports.default = LootTable;
//# sourceMappingURL=LootTable.js.map